import { Card, CardContent } from "@/components/ui/card";

interface PipelineCardProps {
  label: string;
  value: string;
  sublabel?: string;
  color: string;
  icon?: React.ComponentType<{ className?: string }>;
  barPct?: number;
}

export function PipelineCard({
  label,
  value,
  sublabel,
  color,
  icon: Icon,
  barPct,
}: PipelineCardProps) {
  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-start justify-between mb-2">
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
            {label}
          </p>
          {Icon && (
            <div
              className="flex items-center justify-center w-8 h-8 rounded-lg"
              style={{ backgroundColor: `${color}18` }}
            >
              <Icon className="w-4 h-4" style={{ color }} />
            </div>
          )}
        </div>
        <p className="text-2xl font-bold tabular-nums" style={{ color }}>
          {value}
        </p>
        {sublabel && (
          <p className="text-xs text-muted-foreground mt-0.5">{sublabel}</p>
        )}
        {barPct !== undefined && (
          <div className="mt-2 h-1.5 bg-gray-100 rounded-full overflow-hidden">
            <div
              className="h-full rounded-full transition-all duration-500"
              style={{
                width: `${Math.min(100, Math.max(0, barPct))}%`,
                backgroundColor: color,
              }}
            />
          </div>
        )}
      </CardContent>
    </Card>
  );
}
